<ng-container *ngIf="meterGlobalRecords">
	<div class="white-box p-4 border-radius-bottom">
		<div class="preperty-values row">
			<div class="centered-values col-12 col-md-6 col-lg-4 mt-2" *ngIf="canAccessNumbers()">
				<div *ngIf="checkHasAccess('debug_start')">
					<div class="p-4">{{'iotemeter.global_records.debug_start' | translate}}</div>
					<div class="p-4">{{ (meterGlobalRecords.debug_start || 0) | number}}</div>
				</div>
				<div *ngIf="checkHasAccess('debug_end')">
					<div class="p-4">{{'iotemeter.global_records.debug_end' | translate}}</div>
					<div class="p-4">{{ (meterGlobalRecords.debug_end || 0) | number}}</div>
				</div>
				<div *ngIf="checkHasAccess('events_start')">
					<div class="p-4">{{'iotemeter.global_records.events_start' | translate}}</div>
					<div class="p-4">{{ (meterGlobalRecords.events_start || 0) | number}}</div>
				</div>
				<div *ngIf="checkHasAccess('events_end')">
					<div class="p-4">
						{{'iotemeter.global_records.events_end' | translate}}
					</div>
					<div class="p-4">{{ (meterGlobalRecords.events_end || 0) | number}}</div>
				</div>
				<div *ngIf="checkHasAccess('rt_start')">
					<div class="p-4">{{'iotemeter.global_records.rt_start' | translate}}</div>
					<div class="p-4">{{ (meterGlobalRecords.rt_start || 0) | number}}</div>
				</div>
				<div *ngIf="checkHasAccess('rt_end')">
					<div class="p-4">{{'iotemeter.global_records.rt_end' | translate}}</div>
					<div class="p-4">{{ (meterGlobalRecords.rt_end || 0) | number}}</div>
				</div>
				<div *ngIf="checkHasAccess('glitch_start')">
					<div class="p-4">{{'iotemeter.global_records.glitch_start' | translate}}</div>
					<div class="p-4">{{ (meterGlobalRecords.glitch_start || 0) | number}}</div>
				</div>
				<div *ngIf="checkHasAccess('glitch_end')">
					<div class="p-4">{{'iotemeter.global_records.glitch_end' | translate}}</div>
					<div class="p-4">{{ (meterGlobalRecords.glitch_end || 0) | number}}</div>
				</div>
			</div>
			<div class="col-12 col-md-6 col-lg-4 mt-2" *ngIf="canAccessCountersAndLastIds()">
				<div *ngIf="checkHasAccess('start_log_counter')">
					<div class="p-4">{{'iotemeter.global_records.start_log_counter' | translate}}</div>
					<div class="p-4">{{meterGlobalRecords.start_log_counter || 0}}</div>
				</div>
				<div *ngIf="checkHasAccess('start_rt_counter')">
					<div class="p-4">{{'iotemeter.global_records.start_rt_counter' | translate}}</div>
					<div class="p-4">{{meterGlobalRecords.start_rt_counter || 0}}</div>
				</div>
				<div *ngIf="checkHasAccess('start_glitch_counter')">
					<div class="p-4">{{'iotemeter.global_records.start_glitch_counter' | translate}}</div>
					<div class="p-4">{{meterGlobalRecords.start_glitch_counter || 0 }}</div>
				</div>
				<div *ngIf="checkHasAccess('last_event_id')">
					<div class="p-4">{{'iotemeter.global_records.last_event_id' | translate}}</div>
					<div class="p-4">{{meterGlobalRecords.last_event_id || 0 }}</div>
				</div>
				<div *ngIf="checkHasAccess('last_glitch_id')">
					<div class="p-4">{{'iotemeter.global_records.last_glitch_id' | translate}}</div>
					<div class="p-4">{{meterGlobalRecords.last_glitch_id || 0 }}</div>
				</div>
				<div *ngIf="checkHasAccess('last_rt_id')">
					<div class="p-4">{{'iotemeter.global_records.last_rt_id' | translate}}</div>
					<div class="p-4">{{meterGlobalRecords.last_rt_id || 0 }}</div>
				</div>
				<div *ngIf="checkHasAccess('last_debug_id')">
					<div class="p-4">{{'iotemeter.global_records.last_debug_id' | translate}}</div>
					<div class="p-4">{{meterGlobalRecords.last_debug_id || 0 }}</div>
				</div>
			</div>
			<div class="col-12 col-md-6 col-lg-4 mt-2">
				<div *ngIf="checkHasAccess('positive_peak_power') && meterGlobalRecords.historical_positive_peak_power">
					<div class="p-4">{{'iotemeter.global_records.positive_peak_power' | translate}}</div>
					<div class="p-4">{{(meterGlobalRecords.historical_positive_peak_power || 0) | number: '1.2-2' }}</div>
				</div>
				<div *ngIf="checkHasAccess('generated_energy') && meterGlobalRecords.generated_energy">
					<div class="p-4">{{'iotemeter.global_records.generated_energy' | translate}}</div>
					<div class="p-4">{{(meterGlobalRecords.generated_energy || 0) | number: '1.2-2' }}</div>
				</div>
				<ng-container *ngIf="device.config_info.voltage_reference === deviceService.imTypeVoltageLevel.lineToLine">
					<div *ngIf="checkHasAccess('min_voltage')">
						<div class="p-4">{{'iotemeter.global_records.historical_min_voltage_ll' | translate}}</div>
						<div class="p-4">{{minRecordValue('historical_min_voltage_ll', '0', true)}}</div>
					</div>
					<div *ngIf="checkHasAccess('max_voltage')">
						<div class="p-4">{{'iotemeter.global_records.historical_max_voltage_ll' | translate}}</div>
						<div class="p-4">{{minRecordValue('historical_max_voltage_ll', '0', true)}}</div>
					</div>
				</ng-container>
				<ng-container *ngIf="device.config_info.voltage_reference === deviceService.imTypeVoltageLevel.lineToNeutral">
					<div *ngIf="checkHasAccess('min_voltage')">
						<div class="p-4">{{'iotemeter.global_records.min_voltage' | translate}}</div>
						<div class="p-4">{{minRecordValue('historical_min_voltage', '0.00')}}</div>
					</div>
					<div *ngIf="checkHasAccess('max_voltage')">
						<div class="p-4">{{'iotemeter.global_records.max_voltage' | translate}}</div>
						<div class="p-4">{{minRecordValue('historical_max_voltage', '0.00')}}</div>
					</div>
				</ng-container>
				<div *ngIf="checkHasAccess('energy_duration')">
					<div class="p-4">{{'iotemeter.global_records.energy_duration' | translate}}</div>
					<div class="p-4">{{commonService.getFormattedDuration(meterGlobalRecords.total_energy_duration || 0) }}</div>
				</div>
				<div *ngIf="checkHasAccess('max_current')">
					<div class="p-4">{{'iotemeter.global_records.max_current' | translate}}</div>
					<div class="p-4">{{minRecordValue('historical_max_current', '0.00')}}</div>
				</div>
				<div *ngIf="checkHasAccess('negative_peak_power') && meterGlobalRecords.historical_negative_peak_power">
					<div class="p-4">{{'iotemeter.global_records.negative_peak_power' | translate}}</div>
					<div class="p-4">{{(meterGlobalRecords.historical_negative_peak_power || 0) | number: '1.2-2' }}</div>
				</div>
				<div *ngIf="checkHasAccess('consumed_energy') && meterGlobalRecords.consumed_energy">
					<div class="p-4">{{'iotemeter.global_records.consumed_energy' | translate}}</div>
					<div class="p-4">{{(meterGlobalRecords.consumed_energy || 0) | number: '1.2-2'}}</div>
				</div>
				<div
					*ngIf="checkHasAccess('generated_kwhr_reset_snapshot') && meterGlobalRecords.generated_kwhr_reset_snapshot">
					<div class="p-4">{{'iotemeter.global_records.generated_kwhr_reset_snapshot' | translate}}</div>
					<div class="p-4">{{(meterGlobalRecords.generated_kwhr_reset_snapshot || 0) | number: '1.2-2'}}</div>
				</div>
				<div
					*ngIf="checkHasAccess('consumed_kwhr_reset_snapshot') && meterGlobalRecords.consumed_kwhr_reset_snapshot">
					<div class="p-4">{{'iotemeter.global_records.consumed_kwhr_reset_snapshot' | translate}}</div>
					<div class="p-4">{{(meterGlobalRecords.consumed_kwhr_reset_snapshot || 0) | number: '1.2-2'}}</div>
				</div>
				<div
					*ngIf="checkHasAccess('generated_kvarh_reset_snapshot') && meterGlobalRecords.generated_kvarh_reset_snapshot">
					<div class="p-4">{{'iotemeter.global_records.generated_kvarh_reset_snapshot' | translate}}</div>
					<div class="p-4">{{(meterGlobalRecords.generated_kvarh_reset_snapshot || 0) | number: '1.2-2'}}</div>
				</div>
				<div
					*ngIf="checkHasAccess('consumed_kvarh_reset_snapshot') && meterGlobalRecords.consumed_kvarh_reset_snapshot">
					<div class="p-4">{{'iotemeter.global_records.consumed_kvarh_reset_snapshot' | translate}}</div>
					<div class="p-4">{{(meterGlobalRecords.consumed_kvarh_reset_snapshot || 0) | number: '1.2-2'}}</div>
				</div>
				<div *ngIf="checkHasAccess('historical_generated_kvarh') && meterGlobalRecords.historical_generated_kvarh">
					<div class="p-4">{{'iotemeter.global_records.historical_generated_kvarh' | translate}}</div>
					<div class="p-4">{{(meterGlobalRecords.historical_generated_kvarh || 0) | number: '1.2-2' }}</div>
				</div>
				<div *ngIf="checkHasAccess('historical_consumed_kvarh') && meterGlobalRecords.historical_consumed_kvarh">
					<div class="p-4">{{'iotemeter.global_records.historical_consumed_kvarh' | translate}}</div>
					<div class="p-4">{{(meterGlobalRecords.historical_consumed_kvarh || 0) | number: '1.2-2' }}</div>
				</div>
			</div>
		</div>

		<div class="pt-4" *ngIf="canAccessPreviousMeterFields()">
			<h3>{{'iotemeter.global_records.previous_meter_fields' | translate}}</h3>
			<div class="preperty-values row">
				<div class="centered-values col-12 col-md-6 col-lg-4 mt-2">
					<div *ngIf="checkHasAccess('prev_meter_consumed_kwhr')">
						<div class="p-4">{{'iotemeter.global_records.prev_meter_consumed_kwhr' | translate}}</div>
						<div class="p-4">{{(meterGlobalRecords.prev_meter_consumed_kwhr | number: '1.2-2') || '-' }}</div>
					</div>
					<div *ngIf="checkHasAccess('prev_meter_generated_kwhr')">
						<div class="p-4">{{'iotemeter.global_records.prev_meter_generated_kwhr' | translate}}</div>
						<div class="p-4">{{(meterGlobalRecords.prev_meter_generated_kwhr | number: '1.2-2') || '-' }}</div>
					</div>
					<div *ngIf="checkHasAccess('prev_meter_consumed_kvarh')">
						<div class="p-4">{{'iotemeter.global_records.prev_meter_consumed_kvarh' | translate}}</div>
						<div class="p-4">{{(meterGlobalRecords.prev_meter_consumed_kvarh | number: '1.2-2') || '-' }}</div>
					</div>
					<div
						*ngIf="checkHasAccess('prev_meter_generated_kvarh')">
						<div class="p-4">{{'iotemeter.global_records.prev_meter_generated_kvarh' | translate}}</div>
						<div class="p-4">{{(meterGlobalRecords.prev_meter_generated_kvarh | number: '1.2-2') || '-' }}</div>
					</div>
					<div
						*ngIf="checkHasAccess('prev_meter_historical_positive_peak_power')">
						<div class="p-4">{{'iotemeter.global_records.prev_meter_historical_positive_peak_power' | translate}}</div>
						<div class="p-4">{{(meterGlobalRecords.prev_meter_historical_positive_peak_power | number: '1.2-2') || '-'}}</div>
					</div>
					<div
						*ngIf="checkHasAccess('prev_meter_historical_negative_peak_power')">
						<div class="p-4">{{'iotemeter.global_records.prev_meter_historical_negative_peak_power' | translate}}</div>
						<div class="p-4">{{(meterGlobalRecords.prev_meter_historical_negative_peak_power | number: '1.2-2') || '-' }}</div>
					</div>
					<div
						*ngIf="checkHasAccess('prev_meter_historical_max_voltage')">
						<div class="p-4">{{'iotemeter.global_records.prev_meter_historical_max_voltage' | translate}}</div>
						<div class="p-4">{{minRecordValue('prev_meter_historical_max_voltage', '-')}}</div>
					</div>
				</div>
				<div class="centered-values col-12 col-md-6 col-lg-4 mt-2">
					<div
						*ngIf="checkHasAccess('prev_meter_historical_min_voltage')">
						<div class="p-4">{{'iotemeter.global_records.prev_meter_historical_min_voltage' | translate}}</div>
						<div class="p-4">{{minRecordValue('prev_meter_historical_min_voltage', '-')}}</div>
					</div>
					<div
						*ngIf="checkHasAccess('prev_meter_historical_max_current')">
						<div class="p-4">{{'iotemeter.global_records.prev_meter_historical_max_current' | translate}}</div>
						<div class="p-4">{{minRecordValue('prev_meter_historical_max_current', '-')}}</div>
					</div>
					<div
						*ngIf="checkHasAccess('prev_meter_consumed_energy_duration')">
						<div class="p-4">{{'iotemeter.global_records.prev_meter_consumed_energy_duration' | translate}}</div>
						<div class="p-4">{{(meterGlobalRecords.prev_meter_consumed_energy_duration | number: '1.2-2') || '-' }}</div>
					</div>
					<div
						*ngIf="checkHasAccess('prev_meter_historical_max_voltage_ll')">
						<div class="p-4">{{'iotemeter.global_records.prev_meter_historical_max_voltage_ll' | translate}}</div>
						<div class="p-4">{{minRecordValue('prev_meter_historical_max_voltage_ll', '-')}}</div>
					</div>
					<div
						*ngIf="checkHasAccess('prev_meter_historical_min_voltage_ll')">
						<div class="p-4">{{'iotemeter.global_records.prev_meter_historical_min_voltage_ll' | translate}}</div>
						<div class="p-4">{{minRecordValue('prev_meter_historical_min_voltage_ll', '-')}}</div>
					</div>
					<div
						*ngIf="checkHasAccess('prev_meter_sn')">
						<div class="p-4">{{'iotemeter.global_records.prev_meter_sn' | translate}}</div>
						<div class="p-4">{{(meterGlobalRecords.prev_meter_sn || '-') }}</div>
					</div>
					<div
						*ngIf="checkHasAccess('prev_meter_generated_energy_duration')">
						<div class="p-4">{{'iotemeter.global_records.prev_meter_generated_energy_duration' | translate}}</div>
						<div class="p-4">{{(meterGlobalRecords.prev_meter_generated_energy_duration | number: '1.2-2') || '-' }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>